const projectRoot = 'static/examples/domi-ai-round';

const domiAiRoundExamples = [{
    id: 'hello-round',
    projectPath: `${projectRoot}/hello-round.sb3`,
    title: {
        id: 'gui.domiExamples.round.hello.title',
        defaultMessage: 'Hello, round screen'
    },
    description: {
        id: 'gui.domiExamples.round.hello.description',
        defaultMessage: 'Connect the round screen and create a colorful welcome card.'
    },
    preview: 'round-hello',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.round.action.connect',
        defaultMessage: 'Connect the round screen over USB'
    }, {
        id: 'gui.domiExamples.round.action.welcome',
        defaultMessage: 'Set brightness, color and welcome text'
    }]
}, {
    id: 'touch-color',
    projectPath: `${projectRoot}/touch-color.sb3`,
    title: {
        id: 'gui.domiExamples.round.touchColor.title',
        defaultMessage: 'Touch to change color'
    },
    description: {
        id: 'gui.domiExamples.round.touchColor.description',
        defaultMessage: 'Each touch changes the color and updates the touch counter.'
    },
    preview: 'round-touch',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.round.action.touchEvent',
        defaultMessage: 'Respond to the round-screen touch event'
    }, {
        id: 'gui.domiExamples.round.action.alternateColors',
        defaultMessage: 'Alternate two colors with a conditional'
    }, {
        id: 'gui.domiExamples.round.action.countTouches',
        defaultMessage: 'Count and display touches'
    }]
}, {
    id: 'reaction-game',
    projectPath: `${projectRoot}/reaction-game.sb3`,
    title: {
        id: 'gui.domiExamples.round.reaction.title',
        defaultMessage: 'Reaction speed challenge'
    },
    description: {
        id: 'gui.domiExamples.round.reaction.description',
        defaultMessage: 'Wait for the screen to turn green, then touch it to see your reaction time.'
    },
    preview: 'round-reaction',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.randomWait',
        defaultMessage: 'Wait for a random amount of time'
    }, {
        id: 'gui.domiExamples.round.action.timer',
        defaultMessage: 'Use the timer to measure reaction speed'
    }, {
        id: 'gui.domiExamples.round.action.showResult',
        defaultMessage: 'Show the result on the round screen'
    }]
}, {
    id: 'four-zone-controller',
    projectPath: `${projectRoot}/four-zone-controller.sb3`,
    title: {
        id: 'gui.domiExamples.round.controller.title',
        defaultMessage: 'Four-zone sprite controller'
    },
    description: {
        id: 'gui.domiExamples.round.controller.description',
        defaultMessage: 'Divide the round screen into four zones and use touch coordinates to move the Scratch cat.'
    },
    preview: 'round-controller',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.readCoordinates',
        defaultMessage: 'Read the touch X and Y coordinates'
    }, {
        id: 'gui.domiExamples.round.action.divideZones',
        defaultMessage: 'Use conditions to divide four touch zones'
    }, {
        id: 'gui.domiExamples.round.action.moveSprite',
        defaultMessage: 'Move the Scratch cat from the round screen'
    }]
}, {
    id: 'magic-badge',
    projectPath: `${projectRoot}/magic-badge.sb3`,
    title: {
        id: 'gui.domiExamples.round.badge.title',
        defaultMessage: 'Magic check-in badge'
    },
    description: {
        id: 'gui.domiExamples.round.badge.description',
        defaultMessage: 'Design a glowing gradient badge with icons and a celebration animation.'
    },
    preview: 'round-badge',
    mode: 'online',
    actions: [{
        id: 'gui.domiExamples.round.action.drawBadge',
        defaultMessage: 'Combine a gradient, progress ring, icon and positioned text'
    }, {
        id: 'gui.domiExamples.round.action.checkIn',
        defaultMessage: 'Change the badge state after a touch'
    }]
}, {
    id: 'paint-studio',
    projectPath: `${projectRoot}/paint-studio.sb3`,
    title: {
        id: 'gui.domiExamples.round.paint.title',
        defaultMessage: 'Rainbow finger-paint studio'
    },
    description: {
        id: 'gui.domiExamples.round.paint.description',
        defaultMessage: 'Paint colorful dots directly on the round screen and cycle through three colors.'
    },
    preview: 'round-paint',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.paintAtTouch',
        defaultMessage: 'Draw at the live touch coordinates'
    }, {
        id: 'gui.domiExamples.round.action.cyclePaint',
        defaultMessage: 'Cycle three paint colors with variables and conditions'
    }]
}, {
    id: 'target-challenge',
    projectPath: `${projectRoot}/target-challenge.sb3`,
    title: {
        id: 'gui.domiExamples.round.target.title',
        defaultMessage: 'Target hunter challenge'
    },
    description: {
        id: 'gui.domiExamples.round.target.description',
        defaultMessage: 'Hit animated glowing targets and watch the outer score ring grow.'
    },
    preview: 'round-target',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.randomTarget',
        defaultMessage: 'Generate a random target position'
    }, {
        id: 'gui.domiExamples.round.action.hitTest',
        defaultMessage: 'Calculate whether the touch landed near the target'
    }, {
        id: 'gui.domiExamples.round.action.keepScore',
        defaultMessage: 'Keep score and redraw the next round'
    }]
}, {
    id: 'virtual-pet',
    projectPath: `${projectRoot}/virtual-pet.sb3`,
    title: {
        id: 'gui.domiExamples.round.pet.title',
        defaultMessage: 'Domi virtual pet'
    },
    description: {
        id: 'gui.domiExamples.round.pet.description',
        defaultMessage: 'Feed an animated robot pet and watch its color, icon and energy ring react.'
    },
    preview: 'round-pet',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.drawPet',
        defaultMessage: 'Build a polished pet interface from icons, gradients and a progress ring'
    }, {
        id: 'gui.domiExamples.round.action.petEnergy',
        defaultMessage: 'Keep energy between 0 and 5'
    }, {
        id: 'gui.domiExamples.round.action.petMood',
        defaultMessage: 'Switch expressions when feeding or using energy'
    }]
}, {
    id: 'shake-dice',
    projectPath: `${projectRoot}/shake-dice.sb3`,
    title: {
        id: 'gui.domiExamples.round.shakeDice.title',
        defaultMessage: 'Shake lucky dice'
    },
    description: {
        id: 'gui.domiExamples.round.shakeDice.description',
        defaultMessage: 'Shake the round screen to roll a real six-face dice with light, motion and sound.'
    },
    preview: 'round-dice',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.detectShake',
        defaultMessage: 'Respond to the built-in shake sensor'
    }, {
        id: 'gui.domiExamples.round.action.randomDice',
        defaultMessage: 'Generate and store a random number from 1 to 6'
    }, {
        id: 'gui.domiExamples.round.action.animateResult',
        defaultMessage: 'Draw the matching dice face with conditions, light and sound'
    }]
}, {
    id: 'tilt-orbit',
    projectPath: `${projectRoot}/tilt-orbit.sb3`,
    title: {
        id: 'gui.domiExamples.round.tiltOrbit.title',
        defaultMessage: 'Tilt-controlled energy orb'
    },
    description: {
        id: 'gui.domiExamples.round.tiltOrbit.description',
        defaultMessage: 'Tilt, touch and shake the device to steer and charge a glowing audiovisual energy core.'
    },
    preview: 'round-orbit',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.readTilt',
        defaultMessage: 'Read front-back and left-right tilt angles'
    }, {
        id: 'gui.domiExamples.round.action.mapPosition',
        defaultMessage: 'Convert sensor angles into screen coordinates'
    }, {
        id: 'gui.domiExamples.round.action.liveRedraw',
        defaultMessage: 'Combine smooth incremental motion, layered glow, charging and sound feedback'
    }]
}, {
    id: 'rhythm-planet',
    projectPath: `${projectRoot}/rhythm-planet.sb3`,
    title: {
        id: 'gui.domiExamples.round.rhythmPlanet.title',
        defaultMessage: 'Rhythm planet challenge'
    },
    description: {
        id: 'gui.domiExamples.round.rhythmPlanet.description',
        defaultMessage: 'Follow the glowing beat, tap at the perfect moment and build a ten-hit score streak.'
    },
    preview: 'round-rhythm',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.rhythmLoop',
        defaultMessage: 'Create a three-lane audiovisual rhythm loop'
    }, {
        id: 'gui.domiExamples.round.action.rhythmTiming',
        defaultMessage: 'Judge every touch with the timer and keep a combo'
    }, {
        id: 'gui.domiExamples.round.action.rhythmLevelUp',
        defaultMessage: 'Unlock a level-up celebration after ten perfect hits'
    }]
}, {
    id: 'space-dodger',
    projectPath: `${projectRoot}/space-dodger.sb3`,
    title: {
        id: 'gui.domiExamples.round.spaceDodger.title',
        defaultMessage: 'Star voyager: meteor escape'
    },
    description: {
        id: 'gui.domiExamples.round.spaceDodger.description',
        defaultMessage: 'Tilt to steer a glowing spacecraft, dodge falling meteors and touch to activate a shield.'
    },
    preview: 'round-space',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.spaceSteer',
        defaultMessage: 'Map tilt data to the spacecraft position'
    }, {
        id: 'gui.domiExamples.round.action.spaceCollision',
        defaultMessage: 'Detect meteor collisions and update the score'
    }, {
        id: 'gui.domiExamples.round.action.spaceShield',
        defaultMessage: 'Use touch and shake gestures for shields and hyper jumps'
    }]
}, {
    id: 'pet-adventure',
    projectPath: `${projectRoot}/pet-adventure.sb3`,
    title: {
        id: 'gui.domiExamples.round.petAdventure.title',
        defaultMessage: 'AI pet adventure'
    },
    description: {
        id: 'gui.domiExamples.round.petAdventure.description',
        defaultMessage: 'Raise a lively pet with hunger, happiness, levels, feeding, playtime and a shake dance party.'
    },
    preview: 'round-pet-adventure',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.petDashboard',
        defaultMessage: 'Build a two-ring pet status dashboard'
    }, {
        id: 'gui.domiExamples.round.action.petTouchZones',
        defaultMessage: 'Use left and right touch zones for feeding and play'
    }, {
        id: 'gui.domiExamples.round.action.petDance',
        defaultMessage: 'Start an animated sound-and-light dance party by shaking'
    }]
}, {
    id: 'battery-station',
    projectPath: `${projectRoot}/battery-station.sb3`,
    title: {
        id: 'gui.domiExamples.round.batteryStation.title',
        defaultMessage: 'Touch battery station'
    },
    description: {
        id: 'gui.domiExamples.round.batteryStation.description',
        defaultMessage: 'Touch the screen to read the real battery level and turn it into a circular dashboard.'
    },
    preview: 'round-battery',
    mode: 'online',
    level: 'advanced',
    actions: [{
        id: 'gui.domiExamples.round.action.readBattery',
        defaultMessage: 'Read the built-in battery gauge'
    }, {
        id: 'gui.domiExamples.round.action.powerDashboard',
        defaultMessage: 'Use the battery value in text and a progress ring'
    }]
}];

export default domiAiRoundExamples;
